import { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { fetchAllDoseLevelManagementService } from "../../services/doseLevelManagementService";
import { notifyError } from "../../utilities/helper";
import SearchedComponent from "../../components/SearchedComponent";
import { MenuContext } from "../../App";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { Home } from "@mui/icons-material";

const DoseLevelManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [searchedValue, setSearchedValue] = useState("");
  const [addDosePermission, setAddDosePermission] = useState(false);
  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const { systemActions } = useContext(MenuContext);
  const role = localStorage.getItem("role");

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getAllDoseLevelManagementData(
        pageSize,
        page,
        access_token,
        debounceQuery,
      );
    }
  }, [page, pageSize, access_token, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanCreateDosageLevel",
      );
      if (createFound) {
        canAdd = true;
      }
      setAddDosePermission(canAdd);
    } else if (role === "Admin") {
      setAddDosePermission(true);
    }
  }, [systemActions]);

  const getAllDoseLevelManagementData = async (
    pageSize,
    page,
    access_token,
    debouncedSearch = "",
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllDoseLevelManagementService(
        page + 1,
        pageSize,
        access_token,
        debouncedSearch,
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.mesage);
      console.log(err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 400,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/addUpdate-dose-level-management", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {name}
          </button>
        );
      },
    },
    {
      field: "mgDose",
      headerName: "Mg Dose",
      width: 400,
      renderHeader: () => <div className="grid-heading">{"Mg Dose"}</div>,
      renderCell: (params) => {
        const mgDose = params.row.mgDose;

        return <span className="data-font">{mgDose}</span>;
      },
    },
    {
      field: "isEnabled",
      headerName: "Is Enabled",
      width: 400,
      renderHeader: () => <div className="grid-heading">{"Is Enabled"}</div>,
      renderCell: (params) => {
        const isEnabled = params.row.isEnabled;

        return (
          <span className="data-font">
            {isEnabled === true ? "True" : "False"}
          </span>
        );
      },
    },
  ];

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        {/* This stays mounted always */}
        <div className="home-container">
          <p
            className="bread-crumbs-link-container"
            style={{ fontWeight: "600" }}
          >
            <Link className="bread-crumbs-link" to="/">
              Home
            </Link>{" "}
            |{" "}
            <Link className="bread-crumbs-link" to="/dose-level-management">
              Dose Level Management
            </Link>{" "}
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Link className="bread-crumbs-link home-inner-container">
            Set as Home Page
            <span>
              <Home
                sx={{
                  fontSize: "20px",
                }}
              />
            </span>
          </Link>
        </div>

        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Dose Level Management</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Dose Level"
                searchedValue={searchedValue}
              />
              {addDosePermission && (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-dose-level-management")}
                >
                  Add New Dose Level
                </button>
              )}
            </div>
          </Grid2>
        </Grid2>

        {/* Conditionally render just the grid/loader */}
        {load ? (
          <Loader /> // full-page loader
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          />
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default DoseLevelManagement;
